import * as React from "react";
import Image from "next/image";
import Link from "next/link";

import { VideoCameraIcon } from "@heroicons/react/solid";

import ocean from "@public/ocean.jpg";
import logo from "@public/sm-logo.png";

const IndexPage = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen p-4 bg-gray-700 relative font-open-sans">
      <div className="absolute inset-0 bg-[#4391a0]">
        <Image src={ocean} layout="fill" />
      </div>
      <div className="z-50 bg-white bg-opacity-10 backdrop-filter backdrop-blur-xl rounded-2xl text-xl md:p-12 md:max-w-lg max-w-xs p-4">
        <div className="w-48 md:w-64 mb-4 mx-auto">
          <a
            href="https://sea-machines.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image src={logo} alt="sea machines logo" />
          </a>
        </div>
        <div className="inline-block w-min">
          <h2 className="text-white text-xl md:text-3xl w-min whitespace-nowrap">
            THE MACHINE ODYSSEY
          </h2>
          <h2 className="text-brand text-xl md:text-3xl w-min whitespace-nowrap">
            WORLD’S FIRST 1,000nm
          </h2>
          <h2 className="text-brand text-xl md:text-3xl w-min whitespace-nowrap mb-4">
            AUTONOMOUS VOYAGE
          </h2>
          <div className="flex">
            <div className="flex-1 w-0 text-white text-sm md:text-lg">
              Join Sea Machines and our intrepid tug Nellie Bly as we embark on
              a remotely commanded autonomous long-distance journey of discovery
              and demonstration.
            </div>
          </div>
          <div className="mt-8 flex justify-center">
            <Link href="/live">
              <a className="inline-flex leading-4 justify-center py-4 px-4 border border-transparent rounded-md shadow-sm text-sm md:text-md font-medium bg-brand text-black hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <VideoCameraIcon
                  className="-ml-0.5 mr-2 h-4 w-4"
                  aria-hidden="true"
                />
                Go to live dashboard
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexPage;
